"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValuationWidget = void 0;
var preact_1 = require("preact");
var FormContext_1 = require("./Context/FormContext");
var Data_1 = require("./Common/Data");
var ValuationWidgetContext_1 = require("./Context/ValuationWidgetContext");
var ValuationWidgetContent_1 = __importDefault(require("./ValuationWidgetContent"));
var Types_1 = require("./Types");
var defaultValuationMethodMap = {
    'plate': Types_1.PublicValuationMethod.LicensePlate,
    'vin': Types_1.PublicValuationMethod.Vin
};
var ValuationWidget = function (props) {
    var _a;
    // Wrap entire component in Widget & Form context.
    // https://beta.reactjs.org/learn/passing-data-deeply-with-context
    return (0, preact_1.h)(ValuationWidgetContext_1.ValuationWidgetContextProvider, { defaultState: {
            currentValuationMethod: (_a = defaultValuationMethodMap[props.defaultValuationMethod]) !== null && _a !== void 0 ? _a : FormContext_1.initialFormContextState.valuationMethod,
            errors: {
                vin: false,
                plate: false,
                yearMakeModel: false
            },
            configuration: props,
            selectionValues: {
                plateStates: Data_1.licensePlateStates,
                dropdowns: {
                    years: props.modelYears,
                    makes: [],
                    models: []
                }
            }
        } },
        (0, preact_1.h)(FormContext_1.FormContextProvider, { defaultState: FormContext_1.initialFormContextState },
            (0, preact_1.h)(ValuationWidgetContent_1.default, null)));
};
exports.ValuationWidget = ValuationWidget;
